import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql, compose } from 'react-apollo';
import _ from 'lodash';
import moment from 'moment';
// material
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import TablePagination from '@material-ui/core/TablePagination';
import Typography from '@material-ui/core/Typography';
import Search from '@material-ui/icons/Search';
import { Grid } from '@material-ui/core';
import { InlineDatePicker, MuiPickersUtilsProvider } from 'material-ui-pickers';
import DateFnsUtils from '@date-io/date-fns';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';

import { MdCheckCircle, MdRemoveCircle } from 'react-icons/md';
import { CSVLink } from 'react-csv';
import { FaFileExport } from 'react-icons/fa';

import { updateReferralCode } from './mutation';
import { getAllReferralCodeByAdmin } from './queries';
import { Dialog } from '../../../../components';
import CustomInput from '../../../../components/CustomInput/CustomInput';
import styles from './styles';
import { colors } from '../../../../constants';
import config from '../../../../config';

const CustomTableCell = withStyles(theme => ({
  head: {
    backgroundColor: colors.parimary,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);


class TableReferral extends Component {
  state={
    open: false,
    title: '',
    content: '',
    search: '',
    page: 0,
    limit: 15,
    fromDate: null,
    toDate: null,
    typeFilter: '',
  }

  onChangeStatus = (row, active) => {
    const { id } = row;
    const { updateReferralCode } = this.props;
    updateReferralCode({
      variables: {
        id, active,
      },
      refetchQueries: [{ query: getAllReferralCodeByAdmin }],
    }).then((res) => {
      if (res) this.setState({ open: true, content: 'Completed', title: `${active ? 'Active' : 'Deactive'} Referral Code` });
    }).catch(({ graphQLErrors }) => {
      if (graphQLErrors) {
        this.setState({ open: true, content: graphQLErrors[0].message, title: `Erros ${active ? 'Active' : 'Deactive'} Referral Code` });
      }
    });
  }

  onOk = () => {
    this.setState({ open: false });
  }

  onSearch = (event) => {
    this.setState({ search: event.target.value });
  }

  resetFilters = () => {
    this.setState({
      search: '',
      fromDate: null,
      toDate: null,
      typeFilter: '',
      page: 0,
    });
  }

  handleChangePage = (event, page) => {
    this.setState({ page });
  }

  handleChangeRowsPerPage = (event) => {
    this.setState({ limit: event.target.value });
  }

  prepareDataForCSV = () => {
    const { getAllReferralCodeByAdmin } = this.props;
    let referralCodes = getAllReferralCodeByAdmin || [];
    const { search, fromDate, toDate, typeFilter } = this.state;
    
    // Apply type filter first
    if (typeFilter) {
      referralCodes = _.filter(referralCodes, obj => {
        const type = obj.referalCodeType ? obj.referalCodeType.toLowerCase() : '';
        return type === typeFilter.toLowerCase();
      });
    }
    
    // Apply general search (excluding type and date columns)
    if (search) {
      referralCodes = _.filter(referralCodes, function (obj) {
        const codeMatch = obj.code ? obj.code.toLowerCase().includes(search.toLowerCase()) : false;
        const consumerUsername = obj.consumer && obj.consumer.username ? obj.consumer.username.toLowerCase() : '';
        const consumerUsernameMatch = consumerUsername ? consumerUsername.includes(search.toLowerCase()) : false;
        const merchantUsername = obj.merchant && obj.merchant.username ? obj.merchant.username.toLowerCase() : '';
        const merchantUsernameMatch = merchantUsername ? merchantUsername.includes(search.toLowerCase()) : false;
        const usageMatch = obj.listUserEnterCode && obj.listUserEnterCode.some(usage => 
          usage.username && usage.username.toLowerCase().includes(search.toLowerCase())
        );
        return codeMatch || consumerUsernameMatch || merchantUsernameMatch || usageMatch;
      });
    }
    
    // Expand referral codes to show one row per usage
    let data = [];
    referralCodes.forEach(referralCode => {
      if (referralCode.listUserEnterCode && referralCode.listUserEnterCode.length > 0) {
        referralCode.listUserEnterCode.forEach(usage => {
          const date = usage.createdAt ? moment(Number(usage.createdAt)) : null;
          const ownerUsername = referralCode.consumer
            ? referralCode.consumer.username
            : (referralCode.merchant ? referralCode.merchant.username : '');
          data.push({
            Code: referralCode.code || '',
            Username: ownerUsername,
            Type: referralCode.referalCodeType || '',
            'Used By': usage.username || '',
            Date: date ? date.format('MM/DD/YYYY HH:mm') : '',
            Active: referralCode.active ? 'Yes' : 'No',
            usageDate: usage.createdAt,
          });
        });
      } else {
        // If no usages, still include the referral code
        const ownerUsername = referralCode.consumer
          ? referralCode.consumer.username
          : (referralCode.merchant ? referralCode.merchant.username : '');
        data.push({
          Code: referralCode.code || '',
          Username: ownerUsername,
          Type: referralCode.referalCodeType || '',
          'Used By': '',
          Date: '',
          Active: referralCode.active ? 'Yes' : 'No',
          usageDate: null,
        });
      }
    });
    
    // Filter by date range (after expanding to rows)
    if (fromDate || toDate) {
      data = _.filter(data, function (obj) {
        if (!obj.usageDate) return false;
        const usageDate = moment(Number(obj.usageDate)).startOf('day');
        if (fromDate) {
          const from = moment(fromDate).startOf('day');
          if (usageDate.isBefore(from)) {
            return false;
          }
        }
        if (toDate) {
          const to = moment(toDate).startOf('day');
          if (usageDate.isAfter(to)) {
            return false;
          }
        }
        return true;
      });
    }
    
    // Sort by date descending (most recent first)
    data = _.orderBy(data, obj => {
      if (obj.Date) {
        return moment(obj.Date, 'MM/DD/YYYY HH:mm').valueOf();
      }
      return 0;
    }, 'desc');
    
    // Remove usageDate from CSV export (keep it only for filtering)
    return data.map(({ usageDate, ...rest }) => rest);
  };

  onExportToCSV = () => {
    if (this.csvLinkRef) {
      this.csvLinkRef.link.click();
    }
  }

  _renderToolBar = () => {
    const { classes } = this.props;
    const { search, fromDate, toDate, typeFilter } = this.state;
    const { getAllReferralCodeByAdmin } = this.props;
    let referralCodes = getAllReferralCodeByAdmin || [];

    // Apply same filters as in render
    if (typeFilter) {
      referralCodes = _.filter(referralCodes, obj => {
        const type = obj.referalCodeType ? obj.referalCodeType.toLowerCase() : '';
        return type === typeFilter.toLowerCase();
      });
    }
    
    if (search) {
      referralCodes = _.filter(referralCodes, function (obj) {
        const codeMatch = obj.code ? obj.code.toLowerCase().includes(search.toLowerCase()) : false;
        const consumerUsername = obj.consumer && obj.consumer.username ? obj.consumer.username.toLowerCase() : '';
        const consumerUsernameMatch = consumerUsername ? consumerUsername.includes(search.toLowerCase()) : false;
        const merchantUsername = obj.merchant && obj.merchant.username ? obj.merchant.username.toLowerCase() : '';
        const merchantUsernameMatch = merchantUsername ? merchantUsername.includes(search.toLowerCase()) : false;
        const usageMatch = obj.listUserEnterCode && obj.listUserEnterCode.some(usage => 
          usage.username && usage.username.toLowerCase().includes(search.toLowerCase())
        );
        return codeMatch || consumerUsernameMatch || merchantUsernameMatch || usageMatch;
      });
    }
    
    if (fromDate || toDate) {
      referralCodes = _.filter(referralCodes, function (obj) {
        if (!obj.listUserEnterCode || obj.listUserEnterCode.length === 0) {
          return false;
        }
        return obj.listUserEnterCode.some(usage => {
          if (!usage.createdAt) return false;
          const usageDate = moment(Number(usage.createdAt));
          if (fromDate && !usageDate.isSameOrAfter(fromDate, 'day')) {
            return false;
          }
          if (toDate && !usageDate.isSameOrBefore(toDate, 'day')) {
            return false;
          }
          return true;
        });
      });
    }
    
    // Expand referral codes to count total rows
    let totalRows = 0;
    referralCodes.forEach(referralCode => {
      if (referralCode.listUserEnterCode && referralCode.listUserEnterCode.length > 0) {
        totalRows += referralCode.listUserEnterCode.length;
      } else {
        totalRows += 1;
      }
    });
    
    return (
      <>
        <div className={classes.searchWrapper}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <CustomInput
              formControlProps={{
                className: `${classes.margin} ${classes.search}`,
              }}
              inputProps={{
                value: search,
                onChange: this.onSearch,
                placeholder: 'Search',
                inputProps: {
                  'aria-label': 'Search',
                },
              }}
            />
            <Button disabled>
              <Search />
            </Button>
            <FormControl style={{ minWidth: 120 }}>
              <InputLabel shrink>Type</InputLabel>
              <Select
                value={typeFilter}
                onChange={(e) => this.setState({ typeFilter: e.target.value })}
                displayEmpty
              >
                <MenuItem value="">All</MenuItem>
                <MenuItem value="merchant">Merchant</MenuItem>
                <MenuItem value="consumer">Consumer</MenuItem>
              </Select>
            </FormControl>
            <Button variant="contained" color="primary" className={classes.button} onClick={this.onExportToCSV}>
              <Typography component="p" className={classes.text}>Export</Typography>
              <FaFileExport color="#ffffff" size={16} />
            </Button>
            <CSVLink
              data={this.prepareDataForCSV()}
              filename={`referral-codes-${moment().format('YYYY-MM-DD-HHmmss')}.csv`}
              style={{ display: "none" }}
              ref={(r) => this.csvLinkRef = r}
            >
              Export
            </CSVLink>
          </div>
          <Typography component="p" style={{ fontSize: '14px', alignSelf: 'center' }}>
            Rows: {totalRows}
          </Typography>
        </div>
        <div>
          <Typography variant="body1" className={classes.filterLabel}>Date Filter</Typography>
          <Grid key="date-filter" container>
            <Grid key="from" container item xs={12} md={8}>
              <Grid item xs={12} sm={6}>
                <InlineDatePicker
                  label="From"
                  id="date-from"
                  onChange={(date) => this.setState({ fromDate: date })}
                  format="yyyy-MM-dd"
                  value={fromDate}
                />
              </Grid>
              <Grid key="to" item xs={12} sm={6}>
                <InlineDatePicker
                  label="To"
                  id="date-to"
                  onChange={(date) => this.setState({ toDate: date })}
                  format="yyyy-MM-dd"
                  value={toDate}
                />
              </Grid>
            </Grid>
            <Grid key="reset-date-filter" container item xs={12} md={4}>
              <Button variant="contained" color="primary" className={classes.button} onClick={this.resetFilters}>
                Reset
              </Button>
            </Grid>
          </Grid>
        </div>
      </>
    );
  }

  render() {
    const { classes, getAllReferralCodeByAdmin } = this.props;
    let referralCodes = getAllReferralCodeByAdmin || [];
    referralCodes = _.orderBy(referralCodes, obj => obj.id, 'desc');
    const {
      title, content, open, search, page, limit, fromDate, toDate, typeFilter,
    } = this.state;
    
    // Apply type filter first
    if (typeFilter) {
      referralCodes = _.filter(referralCodes, obj => {
        const type = obj.referalCodeType ? obj.referalCodeType.toLowerCase() : '';
        return type === typeFilter.toLowerCase();
      });
    }
    
    // Apply general search (excluding type and date columns)
    if (search) {
      referralCodes = _.filter(referralCodes, function (obj) {
        const codeMatch = obj.code ? obj.code.toLowerCase().includes(search.toLowerCase()) : false;
        const consumerUsername = obj.consumer && obj.consumer.username ? obj.consumer.username.toLowerCase() : '';
        const consumerUsernameMatch = consumerUsername ? consumerUsername.includes(search.toLowerCase()) : false;
        const merchantUsername = obj.merchant && obj.merchant.username ? obj.merchant.username.toLowerCase() : '';
        const merchantUsernameMatch = merchantUsername ? merchantUsername.includes(search.toLowerCase()) : false;
        const usageMatch = obj.listUserEnterCode && obj.listUserEnterCode.some(usage => 
          usage.username && usage.username.toLowerCase().includes(search.toLowerCase())
        );
        return codeMatch || consumerUsernameMatch || merchantUsernameMatch || usageMatch;
      });
    }
    
    // Expand referral codes to show one row per usage
    let data = [];
    referralCodes.forEach(referralCode => {
      if (referralCode.listUserEnterCode && referralCode.listUserEnterCode.length > 0) {
        // Create a row for each usage
        referralCode.listUserEnterCode.forEach(usage => {
          data.push({
            ...referralCode,
            usageUsername: usage.username,
            usageDate: usage.createdAt,
            isUsageRow: true
          });
        });
      } else {
        // If no usages, show one row with empty usage data
        data.push({
          ...referralCode,
          usageUsername: '',
          usageDate: null,
          isUsageRow: false
        });
      }
    });
    
    // Filter by date range (after expanding to rows)
    if (fromDate || toDate) {
      data = _.filter(data, function (obj) {
        if (!obj.usageDate) return false;
        const usageDate = moment(Number(obj.usageDate)).startOf('day');
        if (fromDate) {
          const from = moment(fromDate).startOf('day');
          if (usageDate.isBefore(from)) {
            return false;
          }
        }
        if (toDate) {
          const to = moment(toDate).startOf('day');
          if (usageDate.isAfter(to)) {
            return false;
          }
        }
        return true;
      });
    }
    
    // Sort by date descending (most recent first)
    data = _.orderBy(data, obj => {
      if (obj.usageDate) {
        return moment(Number(obj.usageDate)).valueOf();
      }
      return 0;
    }, 'desc');
    return (
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <div>
          <Dialog
            title={title}
            content={content}
            open={open}
            onOk={() => this.onOk()}
          />
          {this._renderToolBar()}
        <Paper className={classes.root}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <CustomTableCell>Code</CustomTableCell>
                <CustomTableCell align="right" className={classes.columnRow}>Username</CustomTableCell>
                <CustomTableCell align="right" className={classes.columnRow}>Type</CustomTableCell>
                <CustomTableCell align="right" className={classes.columnRow}>Used By</CustomTableCell>
                <CustomTableCell align="right" className={classes.columnRow}>Date</CustomTableCell>
                <CustomTableCell align="center" className={classes.rowEdit}>Active/Deactive</CustomTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.slice(page * limit, page * limit + limit).map((row, index) => {
                return (
                  <TableRow className={classes.row} key={`${row.id}-${row.usageUsername}-${index}`}>
                    <CustomTableCell component="th" scope="row">
                      {row.code}
                    </CustomTableCell>
                    <CustomTableCell align="right" className={classes.colTable}>
                      {row.consumer
                        ? row.consumer.username
                        : (row.merchant ? row.merchant.username : '')
                      }
                    </CustomTableCell>
                    <CustomTableCell align="right" className={classes.colTable}>{row.referalCodeType}</CustomTableCell>
                    <CustomTableCell align="right" className={classes.colTable}>
                      {row.usageUsername || '-'}
                    </CustomTableCell>
                    <CustomTableCell align="right" className={classes.colTable}>
                      {row.usageDate ? moment(Number(row.usageDate)).format('MM/DD/YYYY HH:mm') : '-'}
                    </CustomTableCell>
                    <CustomTableCell align="center" className={classes.columCenter}>
                      {
                        !row.active
                          ? (
                            <Button variant="contained" color="primary" className={classes.buttonActive} onClick={() => this.onChangeStatus(row, true)}>
                              <Typography component="p" className={classes.text}>Activate</Typography>
                            </Button>
                          )
                          : (
                            <Button variant="contained" color="primary" className={classes.buttonDeactive} onClick={() => this.onChangeStatus(row, false)}>
                              <Typography component="p" className={classes.text}>Deactivate</Typography>
                            </Button>
                          )
                      }
                    </CustomTableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          <TablePagination
            rowsPerPageOptions={[15, 25, 50]}
            component="div"
            count={data.length}
            rowsPerPage={limit}
            page={page}
            backIconButtonProps={{
              'aria-label': 'Previous Page',
            }}
            nextIconButtonProps={{
              'aria-label': 'Next Page',
            }}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
          />
        </Paper>
        </div>
      </MuiPickersUtilsProvider>
    );
  }
}

// Mark: default props
TableReferral.defaultProps = {
  classes: {},
  getAllReferralCodeByAdmin: [],
  updateReferralCode: () => {},
};

// Mark: PropsType
TableReferral.propTypes = {
  classes: PropTypes.object,
  getAllReferralCodeByAdmin: PropTypes.array,
  updateReferralCode: PropTypes.func,
};

// Mark: Map data grapql to props
const AllReferralCodeByAdmin = graphql(getAllReferralCodeByAdmin, {
  props: ({ data }) => ({
    loading: data.loading,
    getAllReferralCodeByAdmin: data.getAllReferralCodeByAdmin,
  }),
});

const UpdateReferralCode = graphql(updateReferralCode, { name: 'updateReferralCode' });

export default withStyles(styles)(compose(AllReferralCodeByAdmin, UpdateReferralCode)(TableReferral));
